// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var V4 = require("uuid/v4");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Link = require("next/link").default;
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MyDraftsWidgetDraftListItem_draft_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_draft_graphql.bs.js");
var MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.bs.js");

var convertFragment = MyDraftsWidgetDraftListItem_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_draftOrigin_decode = MyDraftsWidgetDraftListItem_draft_graphql.Utils.draftOrigin_decode;

var DraftFragment_draftOrigin_fromString = MyDraftsWidgetDraftListItem_draft_graphql.Utils.draftOrigin_fromString;

var DraftFragment = {
  draftOrigin_decode: DraftFragment_draftOrigin_decode,
  draftOrigin_fromString: DraftFragment_draftOrigin_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyDraftsWidgetDraftListItem$ConfirmDeleteDialog(props) {
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;
  return JsxRuntime.jsx(ConfirmDialog.make, {
              title: "Delete Draft?",
              ariaLabel: "Confirm Delete Draft",
              body: JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(JsxRuntime.jsx(Text__Jsx3.make, {
                              lineHeight: {
                                NAME: "float",
                                VAL: 1.5
                              },
                              children: "This will delete the draft and cannot be undone."
                            }))
                  }),
              isOpen: props.isOpen,
              onCancel: onCancel,
              cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    children: "No, Keep Draft"
                  }),
              confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                    onClick: (function (param) {
                        onConfirm();
                      }),
                    children: "Yes, Delete Draft"
                  })
            });
}

var ConfirmDeleteDialog = {
  make: MyDraftsWidgetDraftListItem$ConfirmDeleteDialog
};

function MyDraftsWidgetDraftListItem$DeleteDraftButton(props) {
  var onDelete = props.onDelete;
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(MyDraftsWidgetDraftListItem$ConfirmDeleteDialog, {
                      isOpen: match[0],
                      onConfirm: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                          onDelete();
                        }),
                      onCancel: (function () {
                          setIsOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
                      onClick: (function (param) {
                          setIsOpen(function (param) {
                                return true;
                              });
                        }),
                      disabled: props.disabled,
                      size: "small",
                      children: [
                        JsxRuntime.jsx(Icon__Jsx3.make, {
                              icon: "Trash"
                            }),
                        JsxRuntime.jsx(View__Jsx3.make, {
                              ml: "sm"
                            }),
                        "Delete"
                      ]
                    })
              ]
            });
}

var DeleteDraftButton = {
  make: MyDraftsWidgetDraftListItem$DeleteDraftButton
};

var convertVariables = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertVariables;

var convertResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var DeleteDraftV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function MyDraftsWidgetDraftListItem(props) {
  var listConnectionId = props.listConnectionId;
  var draft = use(props.draft);
  var match = use$1();
  var deleteDraft = match[0];
  var match$1 = draft.origin;
  var draftLink;
  if (match$1 !== undefined) {
    var exit = 0;
    if (match$1 === "NEW" || match$1 === "BROADCAST_QUIET_SELLER" || match$1 === "REBROADCAST") {
      switch (match$1) {
        case "NEW" :
            draftLink = "/properties/new?draftId=" + draft.databaseId;
            break;
        case "BROADCAST_QUIET_SELLER" :
        case "REBROADCAST" :
            exit = 1;
            break;
        
      }
    } else {
      draftLink = "#";
    }
    if (exit === 1) {
      var match$2 = draft.publishedProperty;
      draftLink = match$2 !== undefined ? "/properties/" + match$2.id + "/broadcast?resumingDraft=1" : "#";
    }
    
  } else {
    draftLink = "#";
  }
  var match$3 = draft.draftProperty;
  var text;
  if (match$3 !== undefined) {
    var address = match$3.address;
    var match$4 = Core__Option.map(match$3.userSelectedArea, (function (v) {
            return v.name;
          }));
    text = address !== undefined ? (
        match$4 !== undefined ? address + (", " + match$4) : address
      ) : (
        match$4 !== undefined ? match$4 : "(no address entered)"
      );
  } else {
    text = "(no address entered)";
  }
  var match$5 = SystemMessages.useSystemMessages();
  var addMessage = match$5.addMessage;
  var match$6 = draft.origin;
  var tmp;
  if (match$6 !== undefined && (match$6 === "NEW" || match$6 === "BROADCAST_QUIET_SELLER" || match$6 === "REBROADCAST")) {
    switch (match$6) {
      case "BROADCAST_QUIET_SELLER" :
          tmp = "Quiet Property Broadcast";
          break;
      case "NEW" :
          tmp = "New Broadcast";
          break;
      case "REBROADCAST" :
          tmp = "Rebroadcast";
          break;
      
    }
  } else {
    tmp = "";
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(Link, {
                              href: draftLink,
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: tmp,
                                      className: "text-gray-500 uppercase"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: text,
                                      className: ""
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(draft.updatedAt)), "MM/dd/yyyy"),
                              className: "my-2 md:my-0"
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
                              href: draftLink,
                              size: "small",
                              children: [
                                JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Pencil",
                                      size: 15
                                    }),
                                JsxRuntime.jsx(View__Jsx3.make, {
                                      ml: "sm"
                                    }),
                                "Resume"
                              ]
                            }),
                        JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DeleteDraftButton, {
                              onDelete: (function () {
                                  deleteDraft({
                                        connections: Core__Array.keepSome([listConnectionId]),
                                        input: {
                                          draftId: draft.databaseId
                                        }
                                      }, undefined, undefined, undefined, (function (response, param) {
                                          var match = response.deleteDraftV5;
                                          if (match !== undefined && match.__typename === "DraftWasDeleted") {
                                            return addMessage(SystemMessages.Message.make(V4(), "info", "The draft was deleted.", 5000, undefined, undefined));
                                          }
                                          addMessage(SystemMessages.Message.make(V4(), "error", "There was a problem deleting your draft.", 5000, undefined, undefined));
                                        }), undefined, undefined);
                                }),
                              disabled: match[1]
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end"
                    })
              ],
              className: "grid grid-cols-12 gap-2 py-4 border-t"
            });
}

var make = MyDraftsWidgetDraftListItem;

exports.DraftFragment = DraftFragment;
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
exports.DeleteDraftButton = DeleteDraftButton;
exports.DeleteDraftV5Mutation = DeleteDraftV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
